export default "__VITE_ASSET__DKTpr6qD__"